import NiceModal from "@ebay/nice-modal-react";
import ConnectWalletModal from "./components/modals/connectWalletModal/ConnectWalletModal";
import ConnectBtcWalletModal from "./components/modals/connectBtcWalletModal/ConnectBtcWalletModal";

//registeries
 
NiceModal.register("ConnectWalletModal", ConnectWalletModal);
NiceModal.register("ConnectBtcWalletModal", ConnectBtcWalletModal);
